module.exports = __webpack_public_path__ + "static/media/youtube-logo-hover.803708fd.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Footer/youtube-logo-hover.svg
 ** module id = 1310
 ** module chunks = 0
 **/